<template>
  <div style="width: 100%">
    <v-card
      class="card-pad justify-center d-flex align-center mb-4"
      height="75"
      width="100%"
    >
      <v-btn left absolute small text color="grey" @click="$router.go(-1)">
        <v-icon x-small class="mr-1">mdi-arrow-left-bold</v-icon>
        Voltar
      </v-btn>
      <h3><strong>Template de Calibração</strong></h3>
    </v-card>

    <v-form ref="form" style="width: 100%">
      <v-card class="card-pad pa-0 pb-2 mt-4">
        <div class="px-4">
          <v-row class="ma-0 py-4" dense justify="end">
            <v-col class="d-flex align-center">
              <strong>{{ $t('Dados gerais') }}</strong>
            </v-col>
          </v-row>
        </div>

        <v-divider />

        <div class="px-4">
          <v-row class="ma-0" dense>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Instituição') }}</label>
              <v-autocomplete
                hide-details="auto"
                :disabled="true"
                v-model="template.institutionId"
                :loading="institutionLoading"
                :items="institutions"
                item-text="name"
                item-value="id"
                outlined
                append-icon="mdi-chevron-down"
                class="primary-input"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Template') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="template.name"
                outlined
                :rules="[(v) => !!v || 'Template obrigatório']"
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">Equipamentos Padrão</label>
              <v-autocomplete
                hide-details="auto"
                :disabled="loading"
                v-model="selectedEquipments"
                :loading="standardEquipmentLoading"
                :items="standardEquipments"
                :search-input.sync="search"
                @blur="search = ''"
                @change="search = ''"
                multiple
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Equipamento obrigatório']"
                outlined
                append-icon="mdi-chevron-down"
                class="primary-input"
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    color="#BBCF20"
                    text-color="#fff"
                    small
                    @click="select"
                    @click:close="removeStandardEquipment(item)"
                  >
                    {{
                      item.standardEquipment
                        ? item.standardEquipment.name
                        : item.name
                    }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <Parameters v-if="isEditing" />
    </v-form>

    <div></div>

    <div class="d-flex justify-space-between mt-4">
      <v-btn
        depressed
        class="quaternary-button"
        small
        color="#B14949"
        to="/calibration/v2"
      >
        {{ $t('Cancelar') }}
      </v-btn>
      <v-btn
        depressed
        class="secondary-button ma-0"
        small
        :loading="loading"
        @click="submit"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import GeneralService from '../../../../../../services/GeneralService'
import Parameters from './parameters.vue'

export default {
  name: 'TemplateManage',

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    Promise.all([this.getStandardEquipments(), this.getInstitutions()])

    const id = this.$route.query.id
    if (id) {
      this.isEditing = true
      this.getTemplate(id)
    } else this.template.institutionId = this.institution.id
  },

  components: {
    Parameters,
  },

  data() {
    return {
      search: '',
      template: {},
      selectedEquipments: [],
      institutionLoading: false,
      equipmentLoading: false,
      unidadeLoading: false,
      unidades: [],
      equipments: [],
      institution: {},
      institutions: [],
      loading: false,
      isEditing: false,
      standardEquipmentLoading: false,
      standardEquipments: [],
      apiService: new ApiService(),
      generalService: new GeneralService(),
    }
  },

  methods: {
    resetPage(id) {
      if (id) {
        this.isEditing = true
        this.getTemplate(id)
      } else this.template.institutionId = this.institution.id
    },

    removeStandardEquipment(item) {
      this.selectedEquipments.splice(this.selectedEquipments.indexOf(item), 1)
      this.selectedEquipments = [...this.selectedEquipments]
    },

    getInstitutions() {
      this.institutionLoading = true
      this.apiService
        .get(`institution/list`)
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )

      this.standardEquipmentLoading = false
    },

    getTemplate(id) {
      this.apiService.get('calibration/v2/template/' + id).then((response) => {
        this.template = { ...response.content }
        this.selectedEquipments =
          this.template.institutionStandardEquipments.map(
            (x) => x.institutionStandardEquipmentId
          )
      })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      this.template.institutionStandardEquipmentIds = this.selectedEquipments

      if (this.isEditing) this.edit()
      else this.add()
    },

    add() {
      this.loading = true

      this.apiService
        .post('calibration/v2/template', this.template)
        .then((response) => {
          this.$toast.success('Template cadastrado com sucesso!')
          this.$router.push('/calibration/v2?tab=2')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true

      this.apiService
        .put('calibration/v2/template', this.template)
        .then(() => {
          this.$toast.success('Template atualizado com sucesso!')
          this.$router.push('/calibration/v2?tab=2')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}
</style>
